<template>
  <div class="agenda-days-filters"
       v-touch:swipe.left.stop="stopParentSwipe"
       v-touch:swipe.right.stop="stopParentSwipe"
  >
    <VuePerfectScrollbar class="agenda-days-filters" v-if="filters?.days?.length > 1">
      <custom-checkbox-group
          label=""
          :classList="{isLessThenFive: filters?.days?.length <= 5}"
          label-key="name"
          checked-key="is_checked"
          v-model="filters.days"
          @input="handleFilterChange"
          v-slot="{ name, is_checked, index }"
      >
        <div class="agenda-days-filters-day" :class="{active: is_checked}">
          <span class="agenda-days-filters-day__day">{{ parseDate(name).dayShort }}</span>
          <span class="agenda-days-filters-day__month">{{parseDate(name).monthShort}} {{ parseDate(name).dayOfMonth }}</span>
        </div>
      </custom-checkbox-group>
    </VuePerfectScrollbar>
  </div>
</template>


<style lang="scss">

.custom-checkbox-group__form{
  label{
    margin-bottom: 0;
  }
}

.isLessThenFive{
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.agenda-days-filters {

  .ps__thumb-x {
    height: 0;
  }

  //overflow: auto;
  //max-width: 100%;

  .custom-checkbox-group {
    //overflow: hidden;
    //max-width: 100%;
    //min-width: 1px;

    input{
      display: none;
    }
  }

  .custom-checkbox-group__form {
    gap: 0;
    flex-wrap: nowrap;

  }
}

.agenda-days-filters-day {
  color: var(--attendee-text-primary-color);
  //font-size: 14px;
  padding: 0 5px;
  padding-bottom: 10px;
  min-width: 78px;
  font-size: 20px;
  line-height: 24px;




  &__month {
    display: block;
    text-align: center;
    color: var(--attendee-text-secondary-color);
    font-size: 19px;
    text-transform: capitalize;
  }

  &__day {
    text-align: center;
    display: block;
    text-transform: uppercase;

  }

  &.active {
    border-bottom: 4px solid var(--attendee-brand-color);
  }
}
</style>

<script>
import CustomCheckboxGroup from "../ui/form/custom-checkbox-group";
import VuePerfectScrollbar from "vue-perfect-scrollbar";


export default {
  components: {
    CustomCheckboxGroup,
    VuePerfectScrollbar,
  },
  props: {
    filters: {
      type: Object,
      default: {
        search: '',
        days: [],
        formats: [],
        rooms: [],
        topics: [],
        tracks: [],
        types: [],
        visiting_types: [],
        statuses: [],
        timeframe: ['11:00 AM', '06:00 PM'],
        my_presentations: [],
      },
    },
  },
  data() {
    return {
    }
  },
  methods: {

    stopParentSwipe(){

    },

    handleFilterChange() {
      this.$emit('filter', this.filters)
    },
    parseDate(dateStr) {
      if (dateStr !== 'All days') {
        // Розбиваємо вхідний рядок
        const [dayOfWeek, month, dayWithSuffix, year] = dateStr.split(" ");

        // Видаляємо суфікси (st, nd, rd, th) у числі
        const day = dayWithSuffix.replace(/\D/g, "").padStart(2, "0");

        // Отримуємо скорочену назву дня тижня
        const dayShort = dayOfWeek.slice(0, 3);
        const monthShort = month.slice(0, 3);

        // Формуємо об'єкт
        return {
          dayOfMonth: day,
          dayShort,
          monthShort
        };
      }
      return ''
    }
  }
}
</script>